<template>
    <b-modal size="xl" id="itinerary-modal" hide-footer>
        <template #modal-title>
            Booking Itinerary
        </template>

        <div v-if="isLoadingAxumData" class="text-center">
            <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
        </div>

        <div v-if="!isLoadingAxumData" class="table-responsive mb-0">
            <table class="table mb-0 table-centered">
                <thead class="thead-light">
                <tr>
                    <th>Code</th>
                    <th>Title</th>
                    <th>Start</th>
                    <th>Finish</th>
                    <th>From</th>
                    <th>To</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="line in itinerary">
                    <td>
                        {{ line.productTypeCode }}
                    </td>
                    <td>
                        {{ line.itineraryTitle }}
                    </td>
                    <td>
                        {{ formatDate(line.fromDate) }}
                    </td>
                    <td>
                        {{ formatDate(line.toDate) }}
                    </td>
                    <td>
                        {{ line.fromCityCode ? line.fromCityCode : '-' }}
                    </td>
                    <td>
                        {{ line.toCityCode ? line.toCityCode : '-' }}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </b-modal>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "ItineraryModal",
        computed: {
            ...mapGetters('ticketViewer', {
                isLoadingAxumData: 'isLoadingAxumData',
                axumData: 'axumData'
            }),

            itinerary() {
                if (this.axumData.itinerary) {
                   return _.orderBy(this.axumData.itinerary, 'displayOrder');
                }
                return [];
            }
        },
        methods: {
            formatDate(date) {
                if (date) {
                   return moment.utc(date).format('DD/MM/YYYY');
                }
                return '-';
            }
        }
    }
</script>

<style lang="scss">
    #itinerary-modal {
        .modal-body {
            height: 100%;
        }

        .modal-header {
            border-radius: 0;
            background: #2a3042;

            h5, button {
                color: #fff !important;
            }

            button {
                font-weight: normal;
                font-size: 1.5rem;
            }
        }

        .modal-content {
            min-height: 100vh;
            border-radius: 0;
            border: 0;
        }

        .modal-dialog {
            max-width: 100%;
            min-height: 100vh;
            margin: 0 !important;
        }
    }
</style>
